module.exports = __webpack_public_path__ + "img/parter-logo-3.03d72018.jpg";